import React, { useEffect, useState } from "react";

import { GetIntegratorListResponse } from "../api/GetIntegratorListResponse";
import { useAdminIntegratorApi } from "../api/useAdminIntegratorApi";
import { IntegratorItem, mapToIntegratorItem } from "../listing/IntegratorItem";
import { IntegratorContext } from "./IntegratorContext";

interface IntegratorProviderProps {
    children: React.ReactNode;
}

export const IntegratorProvider: React.FC<IntegratorProviderProps> = (props: IntegratorProviderProps) => {
    const { children } = props;
    const { getIntegratorList } = useAdminIntegratorApi();

    const [integratorItems, setIntegratorItems] = useState<IntegratorItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        getIntegratorList()
            .then((response: GetIntegratorListResponse) => {
                const integrators = response.items.map(mapToIntegratorItem);
                setIntegratorItems(integrators);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const addIntegratorItem = (item: IntegratorItem): void => {
        setIntegratorItems((prevItems) => {
            return [item, ...prevItems];
        });
    };

    const deleteIntegratorItem = (integratorId: string) => {
        setIntegratorItems((prevState) => prevState.filter((item: IntegratorItem) => item.id !== integratorId));
    };

    return (
        <IntegratorContext.Provider
            value={{
                integratorItems,
                isLoading,
                setIntegratorItems,
                addIntegratorItem,
                deleteIntegratorItem
            }}
        >
            {children}
        </IntegratorContext.Provider>
    );
};
